<script setup lang="ts">
  defineProps<{
    calendarDays: () => Array<{
      date: Date;
      isCurrentMonth: boolean;
      isPrevMonth?: boolean;
      isNextMonth?: boolean;
    }>;
    selectDate: (date: Date) => void;
    isSelected: (date: Date) => boolean;
    isDateDisabled?: (date: Date) => boolean;
  }>();
</script>

<template>
  <div class="grid grid-cols-7 gap-2">
    <div
      v-for="(day, index) in calendarDays()"
      :key="index"
      class="w-10 h-10 flex items-center justify-center rounded-full text-sm"
      :class="{
        'cursor-pointer': !(isDateDisabled && isDateDisabled(day.date)),
        'text-gray-02': !day.isCurrentMonth,
        'text-gray-07': day.isCurrentMonth && !isSelected(day.date),
        'bg-[color-mix(in_srgb,var(--color-white-01),var(--theme-secondary))] text-white font-medium': isSelected(
          day.date
        ),
        'text-gray-03 cursor-not-allowed opacity-50': isDateDisabled && isDateDisabled(day.date),
      }"
      @click="isDateDisabled && isDateDisabled(day.date) ? null : selectDate(day.date)"
    >
      {{ day.date.getDate() }}
    </div>
  </div>
</template>
